import { gql } from '@apollo/client';
const ADD_TENANT_CATEGORY = gql `
  mutation AddTenantCategory($tenantId: ID!, $name: String!, $image: String!) {
    addModelSpecificationCategory(tenantId: $tenantId, name: $name, image: $image) {
      modelSpecificationCategory {
        id
        name
        image
      }
    }
  }
`;
export default ADD_TENANT_CATEGORY;
